import Axios from 'axios';
import io from 'socket.io-client'
import Config from "../../config/AppConfig";
var _socket = null;
var _deviceToken = null;
var GNS = Config.GNS;
export default class GNSService {
}


/**
 * Creates a new conection with the GNS service and listens for push notifications.
 * @param {*} token 
 */
GNSService.connect = function (token) {
  return new Promise((resolve, reject) => {
    try {
      _deviceToken = token;

      _socket = io.connect(GNS.URL_BASE + GNS.URL_CHANNEL, {
        query: {
          deviceToken: token,
          accessToken: localStorage.getItem('accessToken')
        }
      });
      _socket.on('connect', function () {
      });
      resolve(true)

    } catch (error) {
      reject(error)
    }
  })
}
GNSService.disconnect = function () {
  return new Promise((resolve, reject) => {
    try {
      if (_socket) {
        _socket.removeAllListeners();
        _socket.disconnect();
        resolve(true)
      }
    } catch (error) {
      reject(error)
    }
  })
}
GNSService.subscribe = function (topic,deviceToken) {
  return new Promise((resolve, reject) => {
    let data = {
      topic: topic,
      deviceToken: deviceToken
    }
    Axios.post(Config.GNS.URL_BASE+Config.GNS.URL_SUBSCRIBE, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+localStorage.getItem("accessToken")
      }
    }).then((res) => {
      resolve(res)
    }).catch(reject);
  })

}

GNSService.notification = function (callback) {
  try {
    _socket.on('notification_pushed', function (data) {
      callback(data);
    });
  } catch (error) {
    callback(error)
  }
}

GNSService.unsubscribe = function (topic) {
  return new Promise((resolve, reject) => {
    let data = {
      topic: topic,
      deviceToken: _deviceToken
    }
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
    Axios.post(Config.GNS_UNSUBSCRIBE, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      resolve(res)
    }).catch(reject);
  })

}
/**
     * Sends a new push notification to the GNS server
     * @param {*} topic 
     * @param {*} data 
*/
GNSService.push = function (topic, title, body) {
  return new Promise((resolve, reject) => {
    let notification = {
      topic: topic,
      data: {
        title: title,
        body: body,
        priority: "high"
      }
    };

    Axios.defaults.headers.common['Content-Type'] = 'application/json'
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
    Axios.post(GNS.URL_BASE + GNS.URL_CHANNEL, JSON.stringify(notification), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      resolve(res)
    }).catch(reject);
  })

  /*let notification = {
      topic: "general", data: { "title": "some title", "body": "content", "priority": "high" }
  }*/


}